module.exports = __webpack_public_path__ + "img/pexels-derice-jason-fahnkow-1595244.b917f7ae.jpg";